export default __webpack_public_path__ + "static/media/thumbnail.f438f439.webp";